import { render, staticRenderFns } from "./cooperation-accounts-detail-list.vue?vue&type=template&id=52c66d36&scoped=true&"
import script from "./cooperation-accounts-detail-list.vue?vue&type=script&lang=js&"
export * from "./cooperation-accounts-detail-list.vue?vue&type=script&lang=js&"
import style0 from "./cooperation-accounts-detail-list.vue?vue&type=style&index=0&id=52c66d36&scoped=true&lang=scss&"
import style1 from "./cooperation-accounts-detail-list.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c66d36",
  null
  
)

export default component.exports